import arco from "@/assets/logos/education/arco.svg";
import b3 from "@/assets/logos/education/b3.svg";
import colgate from "@/assets/logos/education/colgate.svg";
import corteva from "@/assets/logos/education/corteva.svg";
import dasa from "@/assets/logos/education/dasa.svg";
import embraer from "@/assets/logos/education/embraer.svg";
import isaEnergia from "@/assets/logos/education/isa-energia.svg";
import jaguar from "@/assets/logos/education/jaguar.svg";
import johnsonEJohnson from "@/assets/logos/education/johnson-e-johnson.svg";
import landRover from "@/assets/logos/education/land-rover.svg";
import loreal from "@/assets/logos/education/loreal.svg";
import nestle from "@/assets/logos/education/nestle.svg";
import nexa from "@/assets/logos/education/nexa.svg";
import petrobras from "@/assets/logos/education/petrobras.svg";
import portoDoAcu from "@/assets/logos/education/porto-do-acu.svg";
import prio from "@/assets/logos/education/prio.svg";
import prudential from "@/assets/logos/education/prudential.svg";
import prumo from "@/assets/logos/education/prumo.svg";
import saintGobain from "@/assets/logos/education/saint-gobain.svg";
import saoMartinho from "@/assets/logos/education/sao-martinho.svg";
import stellantis from "@/assets/logos/education/stellantis.svg";
import volkswagen from "@/assets/logos/education/volkswagen.svg";
import wilsonSons from "@/assets/logos/education/wilson-sons.svg";

export interface EducationPartner {
  name: string;
  logo: string;
  width: number;
  height: number;
}

export const EDUCATION_PARTNERS: EducationPartner[] = [
  { name: "Nestlé", logo: nestle, width: 158.783, height: 52.581 },
  { name: "L'Oréal", logo: loreal, width: 157.394, height: 40.588 },
  { name: "Stellantis", logo: stellantis, width: 217.701, height: 57.63 },
  { name: "B3", logo: b3, width: 64.7, height: 57.612 },
  { name: "Jaguar", logo: jaguar, width: 102, height: 54 },
  { name: "Land Rover", logo: landRover, width: 102, height: 61 },
  { name: "Saint-Gobain", logo: saintGobain, width: 138, height: 67 },
  { name: "PRIO", logo: prio, width: 161, height: 43 },
  { name: "Prudential", logo: prudential, width: 195, height: 53 },
  { name: "Volkswagen", logo: volkswagen, width: 61, height: 61 },
  {
    name: "Johnson & Johnson",
    logo: johnsonEJohnson,
    width: 128,
    height: 57,
  },
  { name: "Embraer", logo: embraer, width: 208, height: 48 },
  { name: "Dasa", logo: dasa, width: 118, height: 43 },
  { name: "Arco", logo: arco, width: 89, height: 54 },
  { name: "Nexa", logo: nexa, width: 105, height: 38 },
  { name: "Colgate", logo: colgate, width: 123, height: 58 },
  { name: "Corteva", logo: corteva, width: 168, height: 34 },
  { name: "ISA Energia", logo: isaEnergia, width: 98, height: 53 },
  { name: "Petrobras", logo: petrobras, width: 108, height: 70 },
  { name: "Porto do Açu", logo: portoDoAcu, width: 85, height: 60 },
  { name: "Prumo", logo: prumo, width: 114, height: 65 },
  { name: "São Martinho", logo: saoMartinho, width: 222, height: 53 },
  { name: "Wilson Sons", logo: wilsonSons, width: 77, height: 60 },
];
